import {
    AttachmentType,
    PermissionResourceType
} from "../../models";
import {
    Box,
    Card,
    CardContent,
    List,
    Typography
} from "@mui/material";

import { RecordingListItem } from "./RecordingListItem";
import globalStyle from "../../assets/style/globalStyle";
import { useFetchAttachments } from "../../lib/attachment/hooks/useFetchAttachments";
import { useMemo } from "react";
import { useCallback } from "react";
import { useParams } from "react-router-dom";
import { Attachment } from "../../models";
import DataStoreAttachmentRecordDAOFactory from "../../lib/attachment/record/datastore/DataStoreAttachmentRecordDAOFactory";
import { useSnackbar } from "notistack";

const attachmentRecordDAO = DataStoreAttachmentRecordDAOFactory.getInstance();

export const RecordingList = () => {
    const { propertyId } = useParams<{ propertyId: string; }>();
    const { attachments, refetch } = useFetchAttachments({ id: propertyId, type: PermissionResourceType.PROPERTY });
    const { enqueueSnackbar } = useSnackbar();

    const globalClasses = globalStyle();

    const videoAttachments = useMemo(() => {
        return attachments?.filter((attachment) => attachment.type === AttachmentType.VIDEO && !!attachment.key);
    }, [attachments]);

    const handleRename = useCallback(async (attachment: Attachment, newName: string) => {
        try {
            // Update the attachment record with the new name
            const updatedAttachment = {
                ...attachment,
                name: newName
            };
            
            await attachmentRecordDAO.update(attachment.id, updatedAttachment);
            
            // Refresh the attachments list to reflect the change
            await refetch();
            
            enqueueSnackbar('Recording renamed successfully', { variant: 'success' });
        } catch (error) {
            console.error('Failed to rename recording:', error);
            enqueueSnackbar('Failed to rename recording', { variant: 'error' });
        }
    }, [refetch, enqueueSnackbar]);

    return (
        !videoAttachments || videoAttachments?.length === 0 ? (
            <></>
        ) : (
            <Box display="flex" flexDirection="column" gap={1}>
                <Typography variant="h6">Meeting Recordings</Typography>
                <Card className={globalClasses.listContainerWithBorder}>
                    <CardContent sx={{ p: "0px !important" }}>
                        <List disablePadding>
                            {videoAttachments?.map((attachment, index) => (
                                <RecordingListItem
                                    key={attachment.id}
                                    attachment={attachment}
                                    onRename={handleRename}
                                    divider={index < videoAttachments.length - 1}
                                />
                            ))}
                        </List>
                    </CardContent>
                </Card>
            </Box>
        )
    );
};